import {
	clearMatrixUpdate,
	setRiskSetupDirty,
	setSaveRun,
} from '@Actions/Risk.actions';
import { RiskGrade, RiskSetupLoFCoF } from '@Components';
import { Grid } from '@mui/material';
import {
	selectIsRiskSetupDirty,
	selectRiskStore,
} from '@Selectors/Risk.selectors';
import React, { useEffect } from 'react';
import { setTab } from '@Actions';
import { useDispatch } from 'react-redux';
import { NavigationPrompt } from '@innovyze/stylovyze';
import { useHistory } from 'react-router-dom';
import { useGlobalization } from '@Translations/useGlobalization';
import { selectRiskRunning } from '@Selectors/util.selectors';

export const RiskSetup = () => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		dispatch(setTab('risk'));
	}, []);

	const riskStore = selectRiskStore();
	const isRiskRunning = selectRiskRunning();

	const isRiskSetupDirty = selectIsRiskSetupDirty();
	const lofTableCells: string[][] = [];
	const cofTableCells: string[][] = [];
	if (!riskStore.isLoading) {
		for (const cat of riskStore.riskConfig.LOFCategories) {
			for (const component of cat.components) {
				if (
					cat.weighting !== 0 &&
					component.select &&
					component.weighting !== 0
				) {
					lofTableCells.push([
						cat.name,
						cat.weighting.toString() + '%',
						component.name,
						cat.useHighestScore
							? '--'
							: component.weighting.toString() + '%',
					]);
				}
			}
		}
		for (const cat of riskStore.riskConfig.COFCategories) {
			for (const component of cat.components) {
				if (
					cat.weighting !== 0 &&
					component.select &&
					component.weighting !== 0
				) {
					cofTableCells.push([
						cat.name,
						cat.weighting.toString() + '%',
						component.name,
						cat.useHighestScore
							? '--'
							: component.weighting.toString() + '%',
					]);
				}
			}
		}
	}

	return (
		<Grid container spacing={3}>
			<NavigationPrompt
				when={isRiskSetupDirty}
				navigate={nextLocation => {
					history.push(nextLocation);
				}}
				onNavigateAway={() => dispatch(setSaveRun(true))}
				secondaryConfirmText={t('Discard')}
				shouldBlockNavigation={() => true}
				shouldBlockReload={isRiskSetupDirty}
				onSecondaryNavigateAway={() => {
					dispatch(clearMatrixUpdate(true));
					dispatch(setRiskSetupDirty(false));
				}}
				content={t(
					'You have modified your Risk model and have unsaved changes.  You can save changes, discard changes, or cancel to continue editing.',
				)}
				confirmText={t('Save')}></NavigationPrompt>
			<Grid item xs={6}>
				<RiskSetupLoFCoF
					isLoading={riskStore.isLoading}
					lofTableCells={lofTableCells}
					cofTableCells={cofTableCells}
				/>
			</Grid>
			<Grid
				item
				xs={6}
				className={
					riskStore.isLoading ||
					riskStore.isPreviewLoading ||
					isRiskRunning
						? 'wait'
						: ''
				}>
				<RiskGrade
					isLoading={
						riskStore.isLoading ||
						riskStore.isPreviewLoading ||
						isRiskRunning
					}
				/>
			</Grid>
		</Grid>
	);
};
